import styled, { css } from 'styled-components';
import { remCalc, colors, media } from '@prisjakt/ui-base';
import ThumbUpIcon from 'mdi-react/ThumbUpIcon';

export const StoreInfo = styled.div`
  margin: 0.4rem 0;
  position: relative;
  width: 100%;
  padding-left: 1rem;
  ${media.smallOnly`
    padding-left: 0.5rem;
  `};
  ${p =>
    p.layout === 'vertical' &&
    css`
      display: flex;
      flex-direction: column;
      justify-items: flex-start;
      padding-left: 0;
      margin: 0;
      padding: 0;
      ${media.smallOnly`
        padding: 0;
      `};
    `}
`;

export const StoreLogoAndRating = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: flex-start;
  > * {
    margin-left: 0.5rem;
    &:first-child {
      margin-left: 0;
    }
  }
  ${media.largeUp`
    align-items: center;
  `}
  ${media.mediumDown`
    flex-direction: column;
    > * {
      margin-left: 0;
    }
  `};
`;

export const RatingContainer = styled.div`
  display: flex;
  flex-direction: row;
  &::after {
    display: inline;
    content: attr(data-rating);
    font-size: ${remCalc(12)};
    line-height: 1.4;
    margin-left: 0.5em;
    color: ${props => props.theme.text.secondary};
  }
`;

export const RecommendedRetailer = styled.div`
  font-size: ${remCalc(12)};
  white-space: nowrap;
  align-self: normal;
  margin-top: 0.3rem;
  color: ${props => props.theme.text.secondary};

  ${media.smallOnly`
    display: none;
  `};
`;

export const RecommendedRetailerIcon = styled(ThumbUpIcon).attrs({ size: 12 })`
  fill: ${colors.darkGray2};
  margin-right: 0.3rem;
`;

export const StoreInfoTitle = styled.span`
  /* Visually hidden since this text is primarily for Google */
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
